<template>
  <div
    v-show="isProgress"
    class="popup"
  >
    <div class="progress">
      <img src="../assets/progress.gif">
    </div>
  </div>
</template>

<script>
export default {
  name: 'Loading',
  props: {
    isProgress: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      msg: 'Footer',
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.progress {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.popup {
  display: block; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 999; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
}
</style>
